import React from 'react';
import { Button } from 'reactstrap';

const ProfileHeaderActions = ({ onNewSale, onEdit, onSave, onCancel, isEditing }) => {
    return (
        <div className="d-flex gap-2">
            {!isEditing && (
                <Button
                    color="light"
                    className="btn-soft-primary border-0 px-4 py-2 fw-bold d-flex align-items-center rounded-0"
                    onClick={onNewSale}
                >
                    <i className="mdi mdi-cart-plus font-size-18 me-2"></i>
                    Nova Venda
                </Button>
            )}
            
            {isEditing ? (
                <>
                    <Button
                        color="secondary"
                        className="btn-soft-secondary border-0 px-4 py-2 fw-bold d-flex align-items-center rounded-0"
                        onClick={onCancel}
                    >
                        Cancelar
                    </Button>
                    <Button
                        color="success"
                        className="btn-soft-success border-0 px-4 py-2 fw-bold d-flex align-items-center rounded-0"
                        onClick={onSave}
                    >
                        Salvar
                    </Button>
                </>
            ) : (
                <Button
                    color="primary"
                    className="btn-soft-info border-0 px-4 py-2 fw-bold d-flex align-items-center rounded-0"
                    onClick={onEdit}
                >
                    <i className="mdi mdi-pencil-outline font-size-18 me-2"></i>
                    Editar Perfil
                </Button>
            )}
        </div>
    );
};

export default ProfileHeaderActions;
